"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AptosNetworkResolver = void 0;
var CommonAptosUtilsConfig_1 = require("./config/CommonAptosUtilsConfig");
var dataTypes_1 = require("./dataTypes");
var AptosNetworkResolver = /** @class */ (function () {
    function AptosNetworkResolver() {
    }
    AptosNetworkResolver.resolve = function (network, core) {
        if (!network) {
            network = core.config.get(CommonAptosUtilsConfig_1.CommonAptosUtilsConfig.defaultAptosNetwork);
        }
        return dataTypes_1.AptosNetwork.create(network).network;
    };
    return AptosNetworkResolver;
}());
exports.AptosNetworkResolver = AptosNetworkResolver;
//# sourceMappingURL=AptosNetworkResolver.js.map